"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var CategoryItem1List_1 = __importDefault(require("./CategoryItem1List"));
var ui_1 = require("@aperza/ui");
var CategoryMenu = /** @class */ (function (_super) {
    __extends(CategoryMenu, _super);
    function CategoryMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showCategoryList: false,
        };
        return _this;
    }
    CategoryMenu.prototype.onMouseOverCategory = function () {
        this.setState({
            showCategoryList: true,
        });
    };
    CategoryMenu.prototype.onMouseLeaveCategory = function (e) {
        var rect = this.categoryMenu.getBoundingClientRect();
        if (e.clientY < rect.bottom) {
            this.setState({
                showCategoryList: false,
            });
        }
    };
    CategoryMenu.prototype.onCloseCategory = function () {
        this.setState({
            showCategoryList: false,
        });
    };
    CategoryMenu.prototype.render = function () {
        var _this = this;
        var productCategories = this.props.productCategories;
        var showCategoryList = this.state.showCategoryList;
        return (react_1.default.createElement("div", { id: "categoryMenu", ref: function (categoryMenu) {
                _this.categoryMenu = categoryMenu;
            }, onMouseOver: this.onMouseOverCategory.bind(this), onMouseLeave: this.onMouseLeaveCategory.bind(this) },
            react_1.default.createElement("a", { className: "categoryDrawer" },
                react_1.default.createElement(ui_1.Message, { messageId: "navbar.category" }),
                react_1.default.createElement("i", { className: "fa fa-caret-down", "aria-hidden": "true" })),
            productCategories && (react_1.default.createElement(CategoryItem1List_1.default, __assign({ show: showCategoryList, productCategories: productCategories, onClose: this.onCloseCategory.bind(this) }, this.props)))));
    };
    CategoryMenu.propTypes = {
        onClose: prop_types_1.default.func,
        disableMarketplaceBanner: prop_types_1.default.bool,
    };
    return CategoryMenu;
}(react_1.default.Component));
exports.default = CategoryMenu;
